import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Customers } from "../Customers/models/customers";
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CustomersService {
  private api: string = '/api/customers';
  
  constructor(private http: HttpClient){}

  /**
   * Recupera el catálogo completo de clientes desde el Address Book.
   */
  getCustomerList(): Observable<Customers[]> {
    return this.http.get<Customers[]>(this.api);
  } 

  /**
   * Registra un nuevo cliente corporativo asignándole manualmente su número AN8.
   */
  createCustomer(customer: Customers): Observable<Customers> {
    return this.http.post<Customers>(this.api, customer);
  }

  /**
   * Modifica los datos de un cliente existente utilizando un PUT real.
   * CORREGIDO: Apunta al AN8 en la URL y envía los datos limpios.
   */
  updateCustomer(customer: Customers): Observable<Customers> {
    return this.http.put<Customers>(`${this.api}/${customer.an8}`, customer);
  }

  /**
   * Elimina un cliente del sistema mediante su código corporativo.
   * CORREGIDO: Cambiado parámetro 'id' por 'an8'.
   */
  deleteCustomerById(an8: number): Observable<any> {
    return this.http.delete(`${this.api}/${an8}`);
  }

  /**
   * Recupera la ficha de un solo cliente para cargarla en el modal de edición.
   * CORREGIDO: Cambiado parámetro 'id' por 'an8'.
   */
  getCustomer(an8: number): Observable<Customers> {
    return this.http.get<Customers>(`${this.api}/${an8}`);
  }

  // Este método devuelve true si el correo ya existe en MySQL, o false si está libre
  verificarCorreoDuplicado(email: string): Observable<boolean> {
    const params = new HttpParams().set('email', email.trim().toUpperCase());
    return this.http.get<boolean>(`${this.api}/check-email`, { params }); // ?email=${email.toUpperCase()}
  }

  verificarRfcDuplicado(rfc: string): Observable<boolean> {
    // 💡 SOLUCIÓN: Usar HttpParams para escapar caracteres especiales como '&' o 'Ñ' de forma segura
    const params = new HttpParams().set('rfc', rfc.trim().toUpperCase());
    return this.http.get<boolean>(`${this.api}/check-rfc`, { params }); // ?rfc=${rfc}
  }

	// Para el asistente de nuevas compañías (SaaS)
  verificarRfcDuplicadoGlobal(rfc: string): Observable<boolean> {
    const params = new HttpParams().set('rfc', rfc.trim().toUpperCase());
    return this.http.get<boolean>(`${this.api.replace('/customers', '/saas')}/check-rfc-global`, { params });
  }

  verificarCorreoDuplicadoGlobal(email: string): Observable<boolean> {
    const params = new HttpParams().set('email', email.trim().toUpperCase());
    return this.http.get<boolean>(`${this.api.replace('/customers', '/saas')}/check-email-global`, { params });
  }  

}

